// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Doctors directory (Stitch Clinical Precision) ——— */
.doctors-screen {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: #ffffff;
}

.doctors-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 16px 24px;
  border-bottom: 1px solid #F1F5F9;
  background: #ffffff;
  flex-shrink: 0;
}

.doctors-heading__left {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.doctors-heading__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.doctors-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.doctors-title-row h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.doctors-count {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  border: 1px solid #E0F2FE;
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  background: #F0F9FF;
  color: #0369A1;
}

.doctors-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.doctors-btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.18);
}

.doctors-btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.doctors-btn--primary .anticon {
  font-size: 14px;
}

.doctors-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 24px;
  border-bottom: 1px solid #F1F5F9;
  background: rgba(248, 250, 252, 0.5);
  flex-shrink: 0;
}

.doctors-toolbar__filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 42rem;
  flex-wrap: wrap;
}

.doctors-toolbar__sort {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.doctors-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 220px;
  min-width: 0;
}

.doctors-search__icon {
  position: absolute;
  left: 12px;
  z-index: 1;
  color: #94A3B8;
  font-size: 14px;
  pointer-events: none;
}

[dir='rtl'] .doctors-search__icon {
  left: auto;
  right: 12px;
}

.doctors-search__input.ant-input-affix-wrapper,
.doctors-search__input.ant-input {
  width: 100%;
  height: 32px;
  padding-left: 36px !important;
  border: 1px solid #E2E8F0 !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  font-size: 12px !important;
  box-shadow: none !important;
}

[dir='rtl'] .doctors-search__input.ant-input-affix-wrapper,
[dir='rtl'] .doctors-search__input.ant-input {
  padding-left: 11px !important;
  padding-right: 36px !important;
}

.doctors-search__input.ant-input-affix-wrapper:focus,
.doctors-search__input.ant-input-affix-wrapper-focused,
.doctors-search__input.ant-input:focus {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.doctors-search__input .ant-input {
  font-size: 12px;
  background: transparent;
}

.doctors-select {
  min-width: 148px;
}

.doctors-select .ant-select-selector {
  height: 32px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  align-items: center !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.doctors-select.ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.doctors-sort-label {
  font-size: 12px;
  font-weight: 500;
  color: #94A3B8;
}

.doctors-sort-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  color: #334155;
  cursor: pointer;
  transition: background 0.12s ease;
}

.doctors-sort-btn:hover {
  background: #F8FAFC;
}

.doctors-sort-btn .anticon {
  font-size: 12px;
  color: #64748B;
}

.doctors-body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 24px;
  background: rgba(248, 250, 252, 0.3);
}

.doctors-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 8px;
  color: #64748B;
  font-size: 13px;
}

.doctors-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 16px;
}

@media (min-width: 768px) {
  .doctors-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1200px) {
  .doctors-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.doctor-card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  padding: 16px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.doctor-card.is-interactive {
  cursor: pointer;
}

.doctor-card.is-interactive:hover {
  border-color: #7DD3FC;
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.1);
}

.doctor-card.is-interactive:hover .doctor-card__name {
  color: #0284C7;
}

.doctor-card__main {
  min-width: 0;
}

.doctor-card__name {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  color: #0F172A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.15s ease;
}

.doctor-card__specialty {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  border: 1px solid #E0F2FE;
  border-radius: 6px;
  background: #F0F9FF;
  font-size: 11px;
  font-weight: 500;
  color: #0369A1;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.doctor-card__meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
}

.doctor-card__meta-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.doctor-card__meta-row.is-muted {
  font-weight: 400;
  color: #64748B;
  font-size: 11px;
}

.doctor-card__meta-row .anticon {
  flex-shrink: 0;
  font-size: 14px;
  color: #94A3B8;
}

.doctor-card__meta-row .is-mono {
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
}

.doctor-card__meta-row .is-truncate {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doctor-card__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
}

.doctor-card__view {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #BAE6FD;
  border-radius: 8px;
  background: #F0F9FF;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  color: #0284C7;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.doctor-card__view:hover {
  background: #0EA5E9;
  border-color: #0EA5E9;
  color: #ffffff;
}

.doctor-card__view .anticon {
  font-size: 10px;
}

[dir='rtl'] .doctor-card__view .anticon {
  transform: scaleX(-1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Doctors/style.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;;EAGE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,6EAA6E;EAC7E,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* ——— Doctors directory (Stitch Clinical Precision) ——— */\n.doctors-screen {\n  box-sizing: border-box;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  background: #ffffff;\n}\n\n.doctors-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 16px 24px;\n  border-bottom: 1px solid #F1F5F9;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.doctors-heading__left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.doctors-heading__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.doctors-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.doctors-title-row h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.doctors-count {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  border: 1px solid #E0F2FE;\n  font-size: 12px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  background: #F0F9FF;\n  color: #0369A1;\n}\n\n.doctors-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.doctors-btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.18);\n}\n\n.doctors-btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.doctors-btn--primary .anticon {\n  font-size: 14px;\n}\n\n.doctors-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 24px;\n  border-bottom: 1px solid #F1F5F9;\n  background: rgba(248, 250, 252, 0.5);\n  flex-shrink: 0;\n}\n\n.doctors-toolbar__filters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: 42rem;\n  flex-wrap: wrap;\n}\n\n.doctors-toolbar__sort {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.doctors-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 220px;\n  min-width: 0;\n}\n\n.doctors-search__icon {\n  position: absolute;\n  left: 12px;\n  z-index: 1;\n  color: #94A3B8;\n  font-size: 14px;\n  pointer-events: none;\n}\n\n[dir='rtl'] .doctors-search__icon {\n  left: auto;\n  right: 12px;\n}\n\n.doctors-search__input.ant-input-affix-wrapper,\n.doctors-search__input.ant-input {\n  width: 100%;\n  height: 32px;\n  padding-left: 36px !important;\n  border: 1px solid #E2E8F0 !important;\n  border-radius: 8px !important;\n  background: #ffffff !important;\n  font-size: 12px !important;\n  box-shadow: none !important;\n}\n\n[dir='rtl'] .doctors-search__input.ant-input-affix-wrapper,\n[dir='rtl'] .doctors-search__input.ant-input {\n  padding-left: 11px !important;\n  padding-right: 36px !important;\n}\n\n.doctors-search__input.ant-input-affix-wrapper:focus,\n.doctors-search__input.ant-input-affix-wrapper-focused,\n.doctors-search__input.ant-input:focus {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.doctors-search__input .ant-input {\n  font-size: 12px;\n  background: transparent;\n}\n\n.doctors-select {\n  min-width: 148px;\n}\n\n.doctors-select .ant-select-selector {\n  height: 32px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  align-items: center !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.doctors-select.ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.doctors-sort-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.doctors-sort-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  color: #334155;\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n\n.doctors-sort-btn:hover {\n  background: #F8FAFC;\n}\n\n.doctors-sort-btn .anticon {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.doctors-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 24px;\n  background: rgba(248, 250, 252, 0.3);\n}\n\n.doctors-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 40vh;\n  gap: 8px;\n  color: #64748B;\n  font-size: 13px;\n}\n\n.doctors-grid {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  gap: 16px;\n}\n\n@media (min-width: 768px) {\n  .doctors-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1200px) {\n  .doctors-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.doctor-card {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.doctor-card.is-interactive {\n  cursor: pointer;\n}\n\n.doctor-card.is-interactive:hover {\n  border-color: #7DD3FC;\n  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.1);\n}\n\n.doctor-card.is-interactive:hover .doctor-card__name {\n  color: #0284C7;\n}\n\n.doctor-card__main {\n  min-width: 0;\n}\n\n.doctor-card__name {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #0F172A;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: color 0.15s ease;\n}\n\n.doctor-card__specialty {\n  display: inline-block;\n  margin-top: 6px;\n  padding: 2px 8px;\n  border: 1px solid #E0F2FE;\n  border-radius: 6px;\n  background: #F0F9FF;\n  font-size: 11px;\n  font-weight: 500;\n  color: #0369A1;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.doctor-card__meta {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.doctor-card__meta-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.doctor-card__meta-row.is-muted {\n  font-weight: 400;\n  color: #64748B;\n  font-size: 11px;\n}\n\n.doctor-card__meta-row .anticon {\n  flex-shrink: 0;\n  font-size: 14px;\n  color: #94A3B8;\n}\n\n.doctor-card__meta-row .is-mono {\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n}\n\n.doctor-card__meta-row .is-truncate {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.doctor-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.doctor-card__view {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid #BAE6FD;\n  border-radius: 8px;\n  background: #F0F9FF;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0284C7;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n}\n\n.doctor-card__view:hover {\n  background: #0EA5E9;\n  border-color: #0EA5E9;\n  color: #ffffff;\n}\n\n.doctor-card__view .anticon {\n  font-size: 10px;\n}\n\n[dir='rtl'] .doctor-card__view .anticon {\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
